import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  supportEmail = 'support@hezkytech.com';
  feUtil = inject(FeUtil)
  constructor(protected location: Location) {}
  config: { address: { [key: string]: string }, phone: string } = {
    address: {
      line1: '501 - G Square,',
      line2: 'Jawahar Road,',
      line3: 'Ghatkopar East,',
      line4: 'Mumbai, Maharashtra 400077',
    },
    phone: '+91 91375 24915'
  };

  ngOnInit(): void {
    if (this.feUtil.getRegion == 'us' || this.feUtil.getRegion == 'local') {
      this.config = {
        address: {
          line1: '16192 Costal Highway',
          line2: 'Lewes, DE 19958',
        },
        phone: '+1 302-227-1222'
      }
    }
  }
}
